<div class="main px-2">
  <div class="row g-3">
    <div class="col-12">
      <app-observacoes-form [observacoes]="observacoes" [dataSet]="dataSet"></app-observacoes-form>
    </div>
    <nz-divider></nz-divider>
    <div class="col-12 d-flex flex-column page-content border border-radius w-100">
      <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
        (nzQueryParams)="sort($event)" [nzNoResult]="semDadosTemplate">
        <thead>
          <tr>
            <th nzColumnKey="data">Data</th>
            <th nzColumnKey="Observacoes">Observações</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of dataSet">
            <td>{{ item?.dataCadastro }}</td>
            <td>{{ item?.textoObservacao }}</td>
            <td class="text-center">
              <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
                <span nz-icon nzType="more" nzTheme="outline"></span>
              </button>
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item type="button" (click)="editarItem(item)">
                    <a> Detalhes</a>
                  </li>
                  <li nz-menu-item type="button" (click)="removerItem(item)">
                    <a> Remover</a>
                  </li>
                </ul>
              </nz-dropdown-menu>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #footerTemplate>
        <section class="d-flex justify-content-end w-100">
          <app-pagination [itemPorPagina]="10"></app-pagination>
        </section>
      </ng-template>
      <ng-template #semDadosTemplate>
        <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
          <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
        </div>
      </ng-template>
    </div>
  </div>
</div>
